export function GroupUser(arrayValue) {
  const value = arrayValue[0];

  switch (value) {
    case 'admin':
      return 'Administrador';
    case 'department':
      return 'Departamento';
    case 'operation':
      return 'Operação';
    case 'recruiter':
      return 'Recrutador';
    default:
      return 'Usuário';
  }
}
